import { BsRecordCircleFill } from 'react-icons/bs';

function PulsingIcon() {
  return (
    <span className="relative flex items-center justify-center w-7 h-7">
      <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75 animate-ping"></span>
      <BsRecordCircleFill className="text-red-500 relative" />
    </span>
  );
}

export default PulsingIcon;
